import React from "react";
import CheckboxGroup from "../../CheckboxGroup";
import { useAlertsFiltersContext } from "../AlertsFiltersProvider";
import { analytics } from "../../../analytics";

const PipelineFilter = () => {
  const {
    eventTypeOptions,
    selectedEventTypes,
    setSelectedEventTypes
  } = useAlertsFiltersContext();

  const updateEventType = (eventTypeName: string) => {
    let newEventTypes = [];
    if (selectedEventTypes.includes(eventTypeName)) {
      newEventTypes = selectedEventTypes.filter(
        event => event !== eventTypeName
      );
    } else {
      newEventTypes = [...selectedEventTypes, eventTypeName];
    }

    setSelectedEventTypes(newEventTypes);
  };

  return (
    <CheckboxGroup
      label="Event Types"
      checkboxValue={selectedEventTypes}
      onChange={(eventTypeName: string) => {
        updateEventType(eventTypeName);
        analytics.alertsAddFilter({ type: "eventType", value: eventTypeName });
      }}
      name="events-filter"
      options={eventTypeOptions}
    />
  );
};

export default PipelineFilter;
